<div class="dropdown-wrapper">
  @if (label) {
    <label>{{ label }}</label>
  }
  <div
    class="dropdown-container"
    [class.invalid]="isShowError"
    [class.disabled]="disabled"
    [class.open]="isOpen"
    (click)="toggleDropdown()"
    >
    <div class="display-content">
      <div class="icon-container">
        <img
          [src]="selectedIconPath"
          (error)="useFallbackIcon($event)"
          alt="Blockchain icon"
          class="dropdown-icon"
          />
      </div>
      <div class="display-text">
        {{ selectedLabel || placeholder }}
      </div>
    </div>
    <div class="arrow-icon" [class.open]="isOpen">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        >
        <path d="M1 1.5L6 6.5L11 1.5" />
      </svg>
    </div>
  </div>
  @if (isOpen) {
    <div class="dropdown-menu" #dropdownMenu>
      @for (option of options; track option.value) {
        <div
          class="dropdown-option"
          (click)="selectOption(option)"
          [class.selected]="option.value === value"
          >
          <div class="option-content">
            <div class="option-icon-container">
              <img
                [src]="getBlockchainIconPath(option.value)"
                (error)="useFallbackIcon($event)"
                alt="Blockchain icon"
                class="option-icon"
                />
            </div>
            <span class="option-label">{{ option.label }}</span>
          </div>
        </div>
      }
    </div>
  }
  @if (metadata.error(); as metadataError) {
    <div class="error-message" role="alert">
      <mat-icon class="error-icon">error_outline</mat-icon>
      {{ metadataError }}
    </div>
  }
  @if (isShowError && errorMessage) {
    <div class="error-message">
      <mat-icon class="error-icon">error_outline</mat-icon>
      {{ errorMessage }}
    </div>
  }
</div>
